import { environment } from "@environments/environment";
import { isPlatform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";

export function getFrontendDomain(): URL {
  return localStorage.getItem("FORCE_LOCAL_DOMAIN") === "true"
    ? new URL("http://localhost:8100")
    : environment.endpoints.frontendDomain;
}

export function isIos(): boolean {
  return isPlatform("ios");
}

export function isAndroid(): boolean {
  return isPlatform("android");
}

export function isIosNative(): boolean {
  return isPlatform("ios") && !isPlatform("mobileweb");
}

export function isAndroidNative(): boolean {
  return isPlatform("android") && !isPlatform("mobileweb");
}

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}
